import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\StorePublicLeadController::__invoke
* @see app/Http/Controllers/StorePublicLeadController.php:13
* @route '/__proexpert/leads'
*/
const StorePublicLeadController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StorePublicLeadController.url(options),
    method: 'post',
})

StorePublicLeadController.definition = {
    methods: ["post"],
    url: '/__proexpert/leads',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\StorePublicLeadController::__invoke
* @see app/Http/Controllers/StorePublicLeadController.php:13
* @route '/__proexpert/leads'
*/
StorePublicLeadController.url = (options?: RouteQueryOptions) => {
    return StorePublicLeadController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\StorePublicLeadController::__invoke
* @see app/Http/Controllers/StorePublicLeadController.php:13
* @route '/__proexpert/leads'
*/
StorePublicLeadController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StorePublicLeadController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\StorePublicLeadController::__invoke
* @see app/Http/Controllers/StorePublicLeadController.php:13
* @route '/__proexpert/leads'
*/
const StorePublicLeadControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: StorePublicLeadController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\StorePublicLeadController::__invoke
* @see app/Http/Controllers/StorePublicLeadController.php:13
* @route '/__proexpert/leads'
*/
StorePublicLeadControllerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: StorePublicLeadController.url(options),
    method: 'post',
})

StorePublicLeadController.form = StorePublicLeadControllerForm

export default StorePublicLeadController